import { useCallback, useEffect, useRef, useState } from "react";
import useClientConfig from "../common/hooks/clientConfigHook";
import ExpressionOfInterestEditor from "../components/expressionOfInterestEditor/ExpressionOfInterestEditor";
import { ExpressionOfInterestNewProvider, useEOIContext } from "../components/expressionOfInterestEditor/ExpressionOfInterestEditorContext";
import { useNavigate } from "react-router-dom";
import ReactForm from "../common/components/ReactForm";
import { Col, Row } from "../common/components/Grid";
import DefaultButton from "../common/components/DefaultButton";
import CustomForm from "../common/components/CustomForm";

const DEFAULT_SUCCESS_FORM = [
    {
        borderless: false,
        rows: [
            [
                { type: 'label', colspan: 12, text: 'Thank you for interest, your submission has been recorded.' }
            ]
        ]
    }
]

const ExpressonOfInterestPublicImpl = () => {
    const clientConfig = useClientConfig();
    const { eoi, update, save, clear } = useEOIContext();
    const [state, setState] = useState('edit');
    const formRef = useRef();

    const handleClear = useCallback(() => {
        clear();
    }, [clear])

    const handleSave = useCallback(async () => {
        if (formRef.current.checkValidity()) {
            const submission = await save();
            if (submission) {
                setState('success');
            }
        }
    }, [save]);

    if (state === 'success') {
        return <div style={{ color: 'black' }}><CustomForm def={clientConfig.expressionOfInterest.successForm ?? DEFAULT_SUCCESS_FORM}></CustomForm></div>
    }

    return <div style={{ color: 'black' }}>
        <ReactForm ref={formRef}>
            <ExpressionOfInterestEditor eoi={eoi} onChange={update} isPublic></ExpressionOfInterestEditor>
        </ReactForm>
        <Row>
            <Col></Col>
            <Col className="px-2" xs="auto">
                <DefaultButton kind="clear" onClick={() => handleClear()}></DefaultButton>
            </Col>
            <Col xs="auto">
                <DefaultButton kind="submit" onClick={() => handleSave()}></DefaultButton>
            </Col>
        </Row>
    </div>
}

const ExpressionOfInterestPublicScreen = () => {
    const clientConfig = useClientConfig();
    const navigate = useNavigate();

    useEffect(() => {
        if(clientConfig.expressionOfInterest && clientConfig.expressionOfInterest.enable !== true) {
            navigate('/login');
        }
    }, [navigate, clientConfig])

    return <ExpressionOfInterestNewProvider>
        <ExpressonOfInterestPublicImpl></ExpressonOfInterestPublicImpl>
    </ExpressionOfInterestNewProvider>
}
export default ExpressionOfInterestPublicScreen;